export interface ColumnWithWeightProps {
  allocation_method: number;
  cap_table: number;
  maturity: number;
  volatility: number;
  weight: number;
  opm_backsolve_date: string;
}

type AccessKeyProps = keyof Omit<ColumnWithWeightProps, 'opm_backsolve_date'>;

interface ColumnWeightValidationProps {
  columnsWithWeights: ColumnWithWeightProps[];
  accessKey?: AccessKeyProps;
}

export const validateWeighting = ({ columnsWithWeights, accessKey = 'weight' }: ColumnWeightValidationProps) => {
  const total = columnsWithWeights.reduce((prev, current) => prev + current[accessKey], 0);
  return total === 1 && columnsWithWeights.every(x => x.weight > 0);
};
